export {}

const copyLinkButton = document.querySelector(".share-buttons__copy-link")

if (copyLinkButton !== null) {
  copyLinkButton.addEventListener("click", function () {
    navigator.clipboard.writeText(window.location.href)
  })
}
